import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-1d927b90"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "common-layout"
};
const _hoisted_2 = {
  class: "top"
};
const _hoisted_3 = ["onClick"];

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("header", null, "解决方案", -1));

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "english"
}, "solution", -1));

const _hoisted_6 = {
  class: "left"
};
const _hoisted_7 = {
  class: "menu"
};

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "解决方案", -1));

const _hoisted_9 = ["onClick"];
const _hoisted_10 = ["onClick"];
const _hoisted_11 = ["onClick"];
const _hoisted_12 = {
  class: "right"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item");

  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb");

  const _component_el_menu_item = _resolveComponent("el-menu-item");

  const _component_el_sub_menu = _resolveComponent("el-sub-menu");

  const _component_el_menu = _resolveComponent("el-menu");

  const _component_router_view = _resolveComponent("router-view");

  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_breadcrumb, {
    separator: "#/solution",
    "separator-icon": _ctx.ArrowRight
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pathList, item => {
      return _openBlock(), _createBlock(_component_el_breadcrumb_item, null, {
        default: _withCtx(() => [_createElementVNode("span", {
          style: {
            "color": "#fff",
            "cursor": "pointer"
          },
          onClick: $event => _ctx.changeBread(item)
        }, _toDisplayString(item.title), 9, _hoisted_3)]),
        _: 2
      }, 1024);
    }), 256))]),
    _: 1
  }, 8, ["separator-icon"])]), _hoisted_4, _hoisted_5, _createElementVNode("main", null, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_hoisted_8, _createVNode(_component_el_menu, {
    "unique-opened": "",
    class: "el-menu-vertical",
    "default-active": '/solution/detail/' + _ctx.$route.params.id,
    ref: "menuRef",
    "default-openeds": _ctx.route.path.slice(0, 14) == '/solution/list' ? [_ctx.$route.params.id + ''] : []
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuList, (item, index) => {
      return _openBlock(), _createBlock(_component_el_sub_menu, {
        index: item.id + '',
        key: item.id,
        class: _normalizeClass(_ctx.num == item.id ? 'active-span' : '')
      }, {
        title: _withCtx(() => [_createElementVNode("span", {
          onClick: $event => _ctx.changeMeauOne(item)
        }, _toDisplayString(item.name), 9, _hoisted_9)]),
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (category, cindex) => {
          return _withDirectives((_openBlock(), _createBlock(_component_el_sub_menu, {
            key: category.id,
            index: category.id + '',
            class: _normalizeClass(_ctx.num == Number('1' + category.id) ? 'active-span' : '')
          }, {
            title: _withCtx(() => [_createElementVNode("span", {
              onClick: $event => _ctx.changeMeauTwo(category, item)
            }, _toDisplayString(category.name), 9, _hoisted_10)]),
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.solutions, (model, ccindex) => {
              return _openBlock(), _createBlock(_component_el_menu_item, {
                key: model.id,
                class: _normalizeClass(_ctx.num == Number('2' + model.id) ? 'active-span' : ''),
                index: `/solution/detail/${model.id}`,
                onClick: $event => _ctx.changeMeauThree(model, item, category)
              }, {
                default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(model.title), 1)]),
                _: 2
              }, 1032, ["class", "index", "onClick"]);
            }), 128))]),
            _: 2
          }, 1032, ["index", "class"])), [[_vShow, item.children]]);
        }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.solutions, (category, cindex) => {
          return _withDirectives((_openBlock(), _createBlock(_component_el_menu_item, {
            key: category.id,
            index: `/solution/detail/${category.id}`,
            class: _normalizeClass(_ctx.num == Number('1' + category.id) ? 'active-span' : '')
          }, {
            title: _withCtx(() => [_createElementVNode("span", {
              onClick: $event => _ctx.changeMeauProducts(category, item)
            }, _toDisplayString(category.title), 9, _hoisted_11)]),
            _: 2
          }, 1032, ["index", "class"])), [[_vShow, item.solutions]]);
        }), 128))]),
        _: 2
      }, 1032, ["index", "class"]);
    }), 128))]),
    _: 1
  }, 8, ["default-active", "default-openeds"])])]), _createElementVNode("div", _hoisted_12, [_createVNode(_component_router_view)])])])]);
}